export const setPrepaidCardChargeUsedHistory = async (context, prepaidCardChargeUsedHistory) => {
  context.commit('SET_PREPAID_CARD_CHARGE_USED_HISTORY', prepaidCardChargeUsedHistory)
}
